import { ValueFormat } from 'globales-projekt-angular';
import { Ergebnisse } from '../ws/ergebnis/ergebnisse.model';
import { AuspraegungGebaeude } from '../ws/dbKlassen/auspraegung-gebaeude.model';

export class TableAuspraegungGebaeude {
  modulbereich!: string;
  modul!: string;
  auspraegung: (string | null)[] = [];
  isUeberschrift = false;

  public static getTableAuspraegungGebaeude(
    ergebnisse: Ergebnisse
  ): TableAuspraegungGebaeude[] {
 
    if (ergebnisse.ergebnisGebaeudeList.length == 0) return [];

    let tableAuspraegungGebaeude: TableAuspraegungGebaeude[] = [];

    let auspraegungGebaeudeList: AuspraegungGebaeude[] =
      ergebnisse.ergebnisGebaeudeList[0].gebaeude.auspraegungGebaeude;

    let currentModulbereich: string = '';
    auspraegungGebaeudeList.forEach((entry) => {
      if (currentModulbereich != entry.modulbereich) {
        let element: TableAuspraegungGebaeude = new TableAuspraegungGebaeude();
        element.isUeberschrift = true;
        element.modulbereich = entry.modulbereich;
        currentModulbereich = element.modulbereich;
        tableAuspraegungGebaeude.push(element);
      }
      
      let element: TableAuspraegungGebaeude = new TableAuspraegungGebaeude();

      element.modulbereich = entry.modulbereich;

      element.modul = entry.modul;
      ergebnisse.ergebnisGebaeudeList
        .slice(ergebnisse.ergebnisGebaeudeList.length === 1 ? 0 : 1)
        .forEach((entry2) => {
          let found: boolean = false;
          entry2.gebaeude.auspraegungGebaeude.forEach((entry3) => {
            if (entry3.modul === element.modul) {
              if (entry3.wert === null)
                element.auspraegung.push(entry3.auspraegung);
              else {
                let valueFormat: ValueFormat = new ValueFormat();
                if (entry3.dimension == undefined)
                  element.auspraegung.push(
                    valueFormat.getStringDecimal(
                      entry3.wert,
                      entry3.nachkommastellen
                    )
                  );
                else
                  element.auspraegung.push(
                    valueFormat.getStringDecimalDimension(
                      entry3.wert,
                      entry3.nachkommastellen,
                      entry3.dimension
                    )
                  );
              }

              found = true;
            }
          });

          if (!found) element.auspraegung.push(null);
        });

      tableAuspraegungGebaeude.push(element);
    });
    
    /*
    tableAuspraegungGebaeude = tableAuspraegungGebaeude.filter(entry => {
     
      const anzahl : number = entry.auspraegung.filter(auspraegung => auspraegung === "Wertfeld").length;
 

        return anzahl !== entry.auspraegung.length;
   
    });
  */


    return tableAuspraegungGebaeude;
  }
}
